import Vue from 'vue';
import Vuex from 'vuex';

import session from './session';

import { } from "./mutations.type";

import { } from "./actions.type";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  getters: {

  },
  actions: {

  },
  modules: {
    session
  }
});
